import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../../../Vas';
import '../../../css/CustomerCertificateUpload.css';
import { ExtendedButton,SelectField,TextField,Icon,MessageBox,DateField } from 'component-lib';
import { DateTimeHelper } from 'utils-lib';
import {ConfirmationsModel, RequestAjaxClass} from 'models-lib';

var moment = require('moment');
moment().format();
class CustomerCertificateUpload extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.files='';
        this.state.fileName='';
        this.keys = [];
        this.state.from = false;
        this.state.to = false;
        this.state.id = false;
        this.CustomerId = props.match.params.CustomerId;
        this.ConfirmationsModel = new ConfirmationsModel([this]);
        this.GetRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.PostRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.load();
    }

    componentDidMount(){
      this.PostRequest.setApiUrl(Vas.ApiUrl);
      this.PostRequest.setApiKey(Vas.ApiKey);
      this.PostRequest.setAuth(true);
      this.PostRequest.setType("POST");
      this.PostRequest.setErrorHandler((data)=>{
        $("#LoadingIconPopUp").removeClass().addClass('hide');
      });
    }

    componentDidUpdate(){
        if (this.state.id === true){
            this.refs.IDField.setState({ editable:true });
        } else {
            this.refs.IDField.setState({ editable:false });
        }
    }

    FileUpload() {
      if (this.checkFields() === true){
        $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
        
        let certificationIndex = this.state.CertificationType.indexOf(",");
        let certification = this.state.CertificationType.substring(0,certificationIndex);
        
        let dateFrom = null;
        if (this.state.CertificateStart){
            let cur = DateTimeHelper.StringToDate(this.state.CertificateStart,false,localStorage.getItem('vas_language'));
            dateFrom = moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00');
        }

        let dateTo = null;

        if (this.state.CertificateEnd){
            let cur = DateTimeHelper.StringToDate(this.state.CertificateEnd,false,localStorage.getItem('vas_language'));
            dateTo = moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00');
        } 

        let ident = null;
        if (this.state.IdentificationNumber){
            ident = this.state.IdentificationNumber;
        } 

        this.ConfirmationsModel.SetRequest(this.PostRequest);
        this.ConfirmationsModel.UploadConfirmation(this.CustomerId,certification,dateFrom,dateTo,ident,this.state.files);
      }
    }

    Update(observer)
    {
      let me =this;
        this.setState({},()=>{
          if(observer === "ConfirmationsAll"){
            let verifications = [];
            for(let i = 0; i < this.ConfirmationsModel.Confirmations.length; i++){
              let verification = this.ConfirmationsModel.Confirmations[i];
              me.keys.push([verification.Ident ,verification.Name,verification.DateFromAllowed,verification.DateToAllowed,verification.IdentificationNumberAllowed]);  
              verifications.push({ Key: [verification.Ident ,verification.Name,verification.DateFromAllowed,verification.DateToAllowed,verification.IdentificationNumberAllowed] , Display: verification.Name });
            }
            
            if (me.refs.CertificateType){
              me.refs.CertificateType.setState({ Data: verifications });
            }
          }
          else if(observer === "UploadConfirmation"){
            $("#LoadingIconPopUp").removeClass().addClass('hide');
            if(this.ConfirmationsModel.UploadSuccess === true){
              Vas.GetView("CustomerCertificateUploadSuccess",{CustomerId:this.CustomerId},true);
            }else{
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.ErrorMessages["UnexpectedError"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            }
          }
        });
    }

    Close(){
        Vas.GetView("CustomerCardData",{Id:this.CustomerId},true);
    }

    storeFile(event){
        let type = event.target.files[0].type;
        if ((type.slice(0,5) === "image") || (type === "application/pdf") || (type === "application/msword") || 
          (type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")){
            this.refs.FileText.setState({ Value:event.target.files[0].name });
            this.setState({ files:event.target.files, fileName:event.target.files[0].name }); 
        }
    }

    load(){
        this.GetRequest.setApiUrl(Vas.ApiUrl);
        this.GetRequest.setApiKey(Vas.ApiKey);
        this.GetRequest.setAuth(true);
        this.ConfirmationsModel.SetRequest(this.GetRequest);

        this.ConfirmationsModel.GetAllConfirmations();
    }

    getValues(){
        $("#CertificateStart").val("");
        $("#CertificateEnd").val("");
        $("#IDField").val("");

        let from = false;
        let to = false;
        let id = false;
        if (document.getElementById('CertificateType').selectedIndex > 0){
            from = this.keys[document.getElementById('CertificateType').selectedIndex-1][2];
            to = this.keys[document.getElementById('CertificateType').selectedIndex-1][3];
            id = this.keys[document.getElementById('CertificateType').selectedIndex-1][4];
        }
        let requiredFields = [];
        requiredFields.push(this.refs.FileText);
        if (from === true){
            requiredFields.push(this.refs.CertificateStart);
        }
        if (to === true){
            requiredFields.push(this.refs.CertificateEnd);
        }
        if (id === true){
            requiredFields.push(this.refs.IDField);
        }
        this.setState({ from:from, to:to, id:id, requiredFields:requiredFields,files:null, fileName:'' });      
    }

    checkFields(){
      if (this.state.requiredFields){
        let count=this.state.requiredFields.length;
        let filled = 0;
        for (let i = 0;i < this.state.requiredFields.length;i++){
            if (this.state.requiredFields[i]){
                if (document.getElementById(this.state.requiredFields[i].props.Id).value.length > 0){
                        filled++;
                }
            }
        }
        if (filled < count){
          ReactDOM.render(<MessageBox
            AppURL={Vas.ApplicationUrl}
            Title={Vas.Resources.Titles["Note"]}
            Message={Vas.Resources.Labels["NotAllFields"]} /> , document.getElementById('messageContainer'));
            return false;
        } else {
          return true;
        }
      } else {
        ReactDOM.render(<MessageBox
          AppURL={Vas.ApplicationUrl}
          Title={Vas.Resources.Titles["Note"]}
          Message={Vas.Resources.Labels["NotAllFields"]} /> , document.getElementById('messageContainer'));
      }
    }

    render()
    {   
        if (this.state.from === false){
            $('#DivFrom').removeClass().addClass("divNotVisible");
        } else {
            $('#DivFrom').removeClass().addClass("divVisible");
        }

        if (this.state.to === false){
            $('#DivTo').removeClass().addClass("divNotVisible");
        } else {
            $('#DivTo').removeClass().addClass("divVisible");
        }
        
        if (this.state.id === false){
            $('#DivId').removeClass().addClass("divNotVisible");
        } else {
            $('#DivId').removeClass().addClass("divVisible");
        }

        let extendedButton = (
          <ExtendedButton
            Id={"btoChoose"}
            Usable={true}
            Text={<Icon  
            Name={"Upload"} 
            Size={18} 
            Color={"black"} 
            PaddingLeft={'0px'} 
            PaddingTop={'0px'} 
            Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />}
            Width={30}
            Height={30}
            Type={"Round"} 
            OnClick={()=>{$("#fileUpload").trigger('click');}}/>
        );

        if(Vas.isIE){
          extendedButton = (
            <ExtendedButton
              Id={"btoChoose"}
              Usable={true}
              Text={<Icon  
              Name={"Upload"} 
              Size={18} 
              Color={"black"} 
              PaddingLeft={'0px'} 
              PaddingTop={'0px'} 
              Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />}
              Width={30}
              Height={30}
              Type={"Round"}/>
          );
        }

        return (
        <div className={'form certificateUploadForm'}>
          <table>
            <thead>
              <tr>
                <th>
                  {Vas.Resources.Labels["UploadCertificate"]}
                  <br/>
                  <br/>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td colSpan={2}><SelectField
                            AppURL={Vas.ApplicationUrl}
                            Width={340}
                            ref={"CertificateType"}
                            Id={"CertificateType"}
                            Editable={true}
                            IsRequired={true}
                            Label={Vas.Resources.Labels["ChooseCertificateType"]}
                            OnChange={()=>{ this.setState({ CertificationType: $("#CertificateType").val() }); this.getValues();}} /></td>
                        </tr>
                      </tbody>
                    </table>
                      <br />
                    <table>
                        <tbody>        
                          <tr>
                            <td className={"btoTd"}>
                              <input
                                id="fileUpload"
                                type="file"
                                className="inputfile"
                                onChange={(event)=>{this.storeFile(event);}}
                                accept="image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf" />
                              <label htmlFor="fileUpload">
                              <div style={{ marginTop: '30px' }}>
                                { extendedButton }
                                </div>
                              </label>
                            </td>
                            <td>
                              <TextField
                                AppURL={Vas.ApplicationUrl}
                                ref={"FileText"}
                                Width={290}
                                Id="FileText"
                                Value={this.state.fileName}
                                Editable={false}
                                Label={Vas.Resources.Labels["File"]+ '*'}
                                OnBlur={()=>{ this.setState({ IdentificationNumber: $("#IdentificationNumber").val() });}} />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}><br />{Vas.Resources.Labels["ValidDocumentFormat"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    <table style={{width:'100%'}}>
                      <tbody>
                        <tr>
                          <td><div
                            id={"DivFrom"}
                            className={"divNotVisible"}><DateField
                              AppURL={Vas.ApplicationUrl}
                              Language={localStorage.getItem("vas_language")}
                              ref={"CertificateStart"}
                              Width={170}
                              Editable={true}
                              IsRequired={true}
                              Id={"CertificateStart"}
                              Label={Vas.Resources.Labels["ValidFrom"]+ '*'} 
                              OnBlur={()=>{ this.setState({ CertificateStart: $("#CertificateStart").val() });}} 
                              /></div></td>
                          <td><div
                            id={"DivTo"}
                            className={"divNotVisible"}><DateField
                              AppURL={Vas.ApplicationUrl}
                              Language={localStorage.getItem("vas_language")}
                              ref={"CertificateEnd"}
                              Width={170}
                              Editable={true}
                              IsRequired={true}
                              Id={"CertificateEnd"}
                              Label={Vas.Resources.Labels["ValidTo"]+ '*'} 
                              OnBlur={()=>{ this.setState({ CertificateEnd: $("#CertificateEnd").val() });}}
                              /></div></td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <div
                              id={"DivId"}
                              className={"divNotVisible"}><TextField
                                AppURL={Vas.ApplicationUrl}
                                ref={"IDField"}
                                Width={335}
                                Id="IDField"
                                Editable={true}
                                IsRequired={true}
                                Label={Vas.Resources.Labels["IdentificationNumber"]+ '*'}
                                OnBlur={()=>{ this.setState({ IdentificationNumber: $("#IDField").val() });}} /></div>
                          </td>
                        </tr>
                        <tr>
                          <td >
                            <ExtendedButton
                              Usable={true}
                              ref={"btoDone"}
                              Text={Vas.Resources.Labels["UploadCertificate"]}
                              Float={'left'}
                              OnClick={()=>{ this.FileUpload();}}
                              Width={150}
                              />
                            
                          </td>
                          <td> 
                              <ExtendedButton
                              Usable={true}
                              Text={Vas.Resources.Labels["Cancel"]}
                              Float={'left'}
                              OnClick={()=>{ this.Close();}}
                              Width={150}
                               />
                            
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        );
    }
}
export default CustomerCertificateUpload;
